var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"hide-details":"","placeholder":_vm.placeholder,"type":_vm.type,"outlined":""},on:{"input":function($event){return _vm.updateValue($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }